
import { useLocation, Outlet } from "react-router-dom";

import Layout from "./Layout.jsx";

const PAGES = {
  Dashboard: "Dashboard",
  CreateProduct: "Create Product",
  ProductDetail: "Product Detail",
};

function _getCurrentPage(url) {
  if (url.endsWith("/")) {
    url = url.slice(0, -1);
  }
  let urlLastPart = url.split("/").pop();
  if (urlLastPart.includes("?")) {
    urlLastPart = urlLastPart.split("?")[0];
  }

  const pageName = Object.keys(PAGES).find(
    (page) => page.toLowerCase() === urlLastPart.toLowerCase()
  );
  return pageName || Object.keys(PAGES)[0];
}

export default function StakingRiskMain() {
  const location = useLocation();
  const currentPage = _getCurrentPage(location.pathname);

  return (
    <Layout currentPageName={currentPage}>
      <Outlet />
    </Layout>
  );
}